import * as React from 'react'

import { IItemCard } from '../interface'

import CollectionButton from '../../buttons/collectionButton'
import FavoriteButton from '../../buttons/favoriteButton/favoriteButton'
import FullscreenButton from '../../buttons/fullscreenButton'

import * as styles from './lockupPreviewActionPanel.module.css'

interface ILockupPreviewActionPanel extends IItemCard {
  fullscreen?: boolean
  onFullscreen?: () => any
}

const LockupPreviewActionPanel = ({
  item,
  onAddToCollections,
  onAddToFavourites,
  fullscreen,
  onFullscreen
}: ILockupPreviewActionPanel) => {
  return (
    <div className={styles.root}>
      {fullscreen && (
        <FullscreenButton
          onClick={onFullscreen}
          className={styles.rightSeparator}
          iconClassName={styles.fullscreenButton}
        />
      )}

      <CollectionButton
        href={`/bookmarks/widget?item_id=${item.id}`}
        onClick={onAddToCollections}
        isActive={false}
        className={styles.rightSeparator}
        iconClassName={styles.collectionButton}
      />
      <FavoriteButton
        href={`/favorites?item_id=${item.id}`}
        onClick={onAddToFavourites}
        isActive={item.ui.isInFavourites}
        iconClassName={styles.favoriteButton}
      />
    </div>
  )
}

export default LockupPreviewActionPanel
